import Quill from "quill";
const QuillHeader = Quill.import("formats/header");

export class Header extends QuillHeader {
  static tagName = ["H1", "H2", "H3"];

  static create(value) {
    if (parseInt(value, 10) > 3) {
      return super.create(3);
    }
    let node = super.create(value);
    return node;
  }
}
